import { Dropdown, DropdownButton } from "react-bootstrap";
import {
  LAST_CONTACT_FILTER_LABEL,
  LAST_CONTACT_FILTER_OPTIONS,
} from "../../../utils/constants/lastContactFilter";

const LastContactBoardFilter = ({
  currentFilter,
  handleFilter,
  submitFilter,
}) => {
  return (
    <DropdownButton
      id="dropdown-last-contact"
      size="lg"
      title={LAST_CONTACT_FILTER_LABEL}
      autoClose="outside"
    >
      <Dropdown.Item href="#/action-2" className="boardlist-nav-drop bg-white">
        <div className="mb-5 text-12 col-md-12">
          <div>
            {LAST_CONTACT_FILTER_OPTIONS.map((option) => (
              <div key={option.value || "none"} className="mb-4 d-flex">
                <input
                  type="checkbox"
                  className="me-3"
                  checked={(currentFilter || "") === option.value}
                  onChange={() => handleFilter(option.value)}
                />
                <label htmlFor="" className="text-dark fs-5">
                  {option.label}
                </label>
              </div>
            ))}
          </div>
        </div>
        <div className="w-100 mt-4">
          <button
            type="button"
            className="w-100 btn text-12 btn-primary py-3"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              submitFilter(null, "", currentFilter);
            }}
          >
            Done
          </button>
        </div>
      </Dropdown.Item>
    </DropdownButton>
  );
};

export default LastContactBoardFilter;
